module.exports = __webpack_public_path__ + "img/event_table_arrow.e323d25c.svg";